import { render, staticRenderFns } from "./AdminLog.vue?vue&type=template&id=486825be&scoped=true&"
import script from "./AdminLog.vue?vue&type=script&lang=js&"
export * from "./AdminLog.vue?vue&type=script&lang=js&"
import style0 from "./AdminLog.vue?vue&type=style&index=0&id=486825be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486825be",
  null
  
)

export default component.exports